import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import PropTypes from "prop-types";
import Checkbox from "material-ui/Checkbox";
import TextField from "material-ui/TextField";
import { connect } from "react-redux";
import { FormAccordionSection, SocialNetworkIcon } from "components";
import { updateMessage, orgInitialState } from "redux/modules/composeboxForm";
import twitterText from "twitter-text";
import xLogo from "../../assets/x-logo.svg";
var MessageArea = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    config: state.config,
    composeboxForm: state.composeboxForm["".concat(orgId)] || orgInitialState,
    organization: state.organization.current,
    organizationId: state.organization.current.id
  };
}, {
  updateMessage: updateMessage
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(MessageArea, _Component);

  var _super = _createSuper(MessageArea);

  function MessageArea() {
    var _this;

    _classCallCheck(this, MessageArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e, value) {
      var organizationId = _this.props.organizationId;

      if (e.target.id === "instagram" && 2200 < value.length) {
        var newValue = value.substring(0, 2200);

        _this.props.updateMessage(e.target.id, newValue, organizationId);
      }

      _this.props.updateMessage(e.target.id, value, organizationId);
    });

    _defineProperty(_assertThisInitialized(_this), "calculateTweetLength", function (inStr) {
      var text = " ".concat(inStr || "").slice(1); // make copy of string

      var attachedLink = _this.props.composeboxForm.linkData && _this.props.composeboxForm.linkData.link ? _this.props.composeboxForm.linkData.link : null;

      if (attachedLink) {
        text += " ".concat(attachedLink);
      }

      return twitterText.getTweetLength(text);
    });

    _defineProperty(_assertThisInitialized(_this), "calculateHashtagLimitReached", function (message) {
      var _arr;

      var maxCount = 30;
      var hashtagRegEx = /(^|\B)#(?![0-9_]+\b)([a-zA-Z0-9_]{1,})(\b|\r)/g;
      var arr = [];
      arr = message === null || message === void 0 ? void 0 : message.match(hashtagRegEx);

      if (maxCount < ((_arr = arr) === null || _arr === void 0 ? void 0 : _arr.length)) {
        var _arr2;

        return /*#__PURE__*/React.createElement("span", {
          style: {
            fontSize: 12,
            color: "red",
            marginLeft: "3em"
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-instagram",
          style: {
            fontSize: 14,
            color: "#D2586A",
            paddingRight: 5
          }
        }), "(".concat((_arr2 = arr) === null || _arr2 === void 0 ? void 0 : _arr2.length, "/").concat(maxCount, ")"), " Tags");
      } else return;
    });

    return _this;
  }

  _createClass(MessageArea, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var composeboxForm = this.props.composeboxForm;
      var advancedMessageArea = /*#__PURE__*/React.createElement(FormAccordionSection, {
        toggleLabel: "Advanced",
        open: !!composeboxForm.messages.facebook || !!composeboxForm.messages.twitter || !!composeboxForm.messages.linkedin || !!composeboxForm.messages.instagram || !!composeboxForm.messages.googleMybusiness
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          margin: "0 10px"
        },
        id: "test-advancedmessagewrap"
      }, (composeboxForm.selectedAccounts.facebookProfile || composeboxForm.selectedAccounts.facebookPage) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(TextField, {
        id: "facebook",
        multiLine: true,
        onChange: function onChange(e, value) {
          return _this2.handleChange(e, value);
        },
        style: {
          width: "100%"
        },
        value: composeboxForm.messages.facebook,
        floatingLabelText: "Custom Facebook Message",
        floatingLabelFixed: true
      }))), composeboxForm.selectedAccounts.instagram && /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 12
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(TextField, {
        id: "instagram",
        multiLine: true,
        onChange: function onChange(e, value) {
          return _this2.handleChange(e, value);
        },
        style: {
          width: "100%"
        },
        value: composeboxForm.messages.instagram,
        floatingLabelText: "Custom Instagram Message",
        floatingLabelFixed: true
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 12,
          color: 2200 - (composeboxForm.messages.instagram ? composeboxForm.messages.instagram.length : 0) < 0 ? "red" : "black"
        }
      }, 2200 - (composeboxForm.messages.instagram ? composeboxForm.messages.instagram.length : 0), " ", "Characters Remaining"), this.calculateHashtagLimitReached(composeboxForm.messages.instagram))), composeboxForm.selectedAccounts.twitter && /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 12
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(TextField, {
        id: "twitter",
        multiLine: true,
        onChange: function onChange(e, value) {
          return _this2.handleChange(e, value);
        },
        style: {
          width: "100%"
        },
        value: composeboxForm.messages.twitter,
        floatingLabelText: "Custom X (Twitter) Message",
        floatingLabelFixed: true
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 12,
          color: 280 - this.calculateTweetLength(composeboxForm.messages.twitter) < 0 ? "red" : "black"
        }
      }, 280 - this.calculateTweetLength(composeboxForm.messages.twitter), " ", "Characters Remaining"))), (composeboxForm.selectedAccounts.linkedinCompany || composeboxForm.selectedAccounts.linkedinProfile) && /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 12
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(TextField, {
        id: "linkedin",
        multiLine: true,
        onChange: function onChange(e, value) {
          return _this2.handleChange(e, value);
        },
        style: {
          width: "100%"
        },
        value: composeboxForm.messages.linkedin,
        floatingLabelText: "Custom LinkedIn Message",
        floatingLabelFixed: true
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 12,
          color: 2000 - (composeboxForm.messages.linkedin ? composeboxForm.messages.linkedin.length : 0) < 0 ? "red" : "black"
        }
      }, 2000 - (composeboxForm.messages.linkedin ? composeboxForm.messages.linkedin.length : 0), " ", "Characters Remaining"))), composeboxForm.selectedAccounts.googleMybusiness && /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 12
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(TextField, {
        id: "googleMybusiness",
        multiLine: true,
        onChange: function onChange(e, value) {
          return _this2.handleChange(e, value);
        },
        style: {
          width: "100%"
        },
        value: composeboxForm.messages.googleMybusiness,
        floatingLabelText: "Custom Google Business Profile Message",
        floatingLabelFixed: true
      })))));
      var temp = "";
      var showAdvancedMessage = composeboxForm.selectedAccounts.facebookProfile || composeboxForm.selectedAccounts.facebookPage || composeboxForm.selectedAccounts.linkedinCompany || composeboxForm.selectedAccounts.linkedinProfile || composeboxForm.selectedAccounts.googleMybusiness || composeboxForm.selectedAccounts.twitter;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(TextField, {
        id: "global",
        multiLine: true,
        onChange: function onChange(e, value) {
          return _this2.handleChange(e, value);
        },
        style: {
          width: "100%"
        },
        value: composeboxForm.messages.global
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "space-between"
        }
      }, composeboxForm.selectedAccounts.twitter && !composeboxForm.messages.twitter && /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "space-between"
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: xLogo,
        style: {
          height: '10px',
          fontSize: 14,
          paddingRight: 5
        }
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 12,
          color: 280 - this.calculateTweetLength(composeboxForm.messages.global) < 0 ? "red" : "black"
        }
      }, 280 - this.calculateTweetLength(composeboxForm.messages.global), " ", "Characters Remaining")), /*#__PURE__*/React.createElement("div", null, composeboxForm.selectedAccounts.instagram && !composeboxForm.messages.instagram && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-instagram",
        style: {
          fontSize: 14,
          color: "#D2586A",
          paddingRight: "5px"
        }
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 12,
          color: 2200 - composeboxForm.messages.global.length < 0 ? "red" : "black"
        }
      }, 2200 - composeboxForm.messages.global.length, " ", "Characters Remaining"), this.calculateHashtagLimitReached(composeboxForm.messages.global))), (composeboxForm.selectedAccounts.linkedinCompany || composeboxForm.selectedAccounts.linkedinProfile) && !composeboxForm.messages.linkedin && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-linkedin",
        style: {
          fontSize: 14,
          color: "#007bb5",
          paddingRight: 5
        }
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 12,
          color: 2000 - (composeboxForm.messages.global ? composeboxForm.messages.global.length : 0) < 0 ? "red" : "black"
        }
      }, 2000 - (composeboxForm.messages.global ? composeboxForm.messages.global.length : 0), " ", "Characters Remaining"))), advancedMessageArea);
    }
  }]);

  return MessageArea;
}(Component)) || _class);
export { MessageArea as default };